<template>
  <div class="right">

    <rightTop @data="getCreditDataFn"></rightTop>

    <div class="rightCenter">
      <div class="centerTit">公司高管</div>
      <div @click="downloadFn(0)" class="centerCon">
        <div class="excel" style="cursor: pointer;">
          <img src="@/assets/img/Excel.png" alt />
          下载数据到Excel
        </div>
      </div>
    </div>
    <div class="rightBottom">
      <!-- 第一套 -->
      <div class="tabulation">
        <div style="width:100%;overflow: hidden;margin-bottom:11px;">
          <div style="display: inline-block;float:left;font-size:14px;font-weight:400;height: 32px;vertical-align: middle;line-height: 32px;color: #fff;">高管层</div>
        </div>
        <table class="mailTable">
          <el-table :data="tableData1" border size="mini" style="width: 100%" :header-cell-style="cellStyle">
            <el-table-column prop="userName" label="姓名">
              <template slot-scope="scope">
                <span @click="handlePersonPageFn(scope.row)" style="color:#3583ED;cursor:pointer;">{{scope.row.userName}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="duty" label="职务"></el-table-column>
            <el-table-column prop="startDate" label="起始时间"></el-table-column>
            <el-table-column prop="endDate" label="终止时间"></el-table-column>
          </el-table>
        </table>
      </div>
      <!-- 第二套 -->
      <div class="tabulation" style="margin-top:41px;">
        <div style="width:100%;overflow: hidden;margin-bottom:11px;">
          <el-select @change="SelectTimeFn2" v-model="searchData2.value" size="small" placeholder="请选择" style="width:165px;float:right;">
            <el-option
              v-for="item in searchData2.select"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
          <div style="display: inline-block;float:left;font-size:14px;font-weight:400;height: 32px;vertical-align: middle;line-height: 32px;color: #fff;">董事会</div>
        </div>
        <table class="mailTable">
          <el-table :data="tableData2" border size="mini" style="width: 100%" :header-cell-style="cellStyle">
            <el-table-column prop="userName" label="姓名">
              <template slot-scope="scope">
                <span @click="handlePersonPageFn(scope.row)" style="color:#3583ED;cursor:pointer;">{{scope.row.userName}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="duty" label="职务"></el-table-column>
            <el-table-column prop="startDate" label="起始时间"></el-table-column>
            <el-table-column prop="endDate" label="终止时间"></el-table-column>
          </el-table>
        </table>
      </div>
      <!-- 第三套 -->
      <div class="tabulation" style="margin-top:41px;">
        <div style="width:100%;overflow: hidden;margin-bottom:11px;">
          <el-select @change="SelectTimeFn3" v-model="searchData3.value" size="small" placeholder="请选择" style="width:165px;float:right;">
            <el-option
              v-for="item in searchData3.select"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
          <div style="display: inline-block;float:left;font-size:14px;font-weight:400;height: 32px;vertical-align: middle;line-height: 32px;color: #333333;">监事会</div>
        </div>
        <table class="mailTable">
          <el-table :data="tableData3" border size="mini" style="width: 100%" :header-cell-style="cellStyle">
            <el-table-column prop="userName" label="姓名">
              <template slot-scope="scope">
                <span @click="handlePersonPageFn(scope.row)" style="color:#3583ED;cursor:pointer;">{{scope.row.userName}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="duty" label="职务"></el-table-column>
            <el-table-column prop="startDate" label="起始时间"></el-table-column>
            <el-table-column prop="endDate" label="终止时间"></el-table-column>
          </el-table>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/../static/common/api/api.js";
import magic from "@/../static/common/magic.js";
import rightTop from "@/components/rightTop";
import $ from 'jquery';
export default {
  data() {
    return {
      tableData1:[],
      tableData2:[],
      tableData3:[],
      //选择数据
      searchData1:{
        select:[],//下拉框选项数据
        value: '',
      },
      searchData2:{
        select:[],//下拉框选项数据
        value: '',
      },
      searchData3:{
        select:[],//下拉框选项数据
        value: '',
      },
      companyList:[],
      paramsData:{}//URL参数集合
    };
  },
  components:{
    rightTop
  },
  methods: {
    cellStyle(row,column,rowIndex,columnIndex){
      return 'color: #333333;font-weight:bold;font-family:Microsoft YaHei;background:#F7F7F7;'
    },
    //收藏组件方法部分
    getCreditDataFn(data){
      this.paramsData.stockCode = data[0].companyStockCode;
      this.paramsData.enterpriseCode = data[0].enterpriseCode;
      this.paramsData.companyName = data[0].companyFullName;
      this.action();//获取表格数据
    },
    //点击人名进入个人详情页
    handlePersonPageFn(row){
      
      let {href}=this.$router.resolve({
        path: "/personinfo",
        query: {
          stockCode: this.paramsData.stockCode,
          enterpriseCode: this.paramsData.enterpriseCode,
          persionCode: row.personCode,
          name: row.userName,
          dbcode: this.$route.params.dbcode,
          company:this.paramsData.companyName
        }
      });
      window.open(href,'_blank')

    },
    //下载函数
    downloadFn(incomeType){
      let _this = this;
      this.download(window.baseUrl + '/companyBasic/downExecutivesData?stockCode=' + this.paramsData.stockCode + '&enterpriseCode=' + this.paramsData.enterpriseCode + '&sessionDNum=' + this.searchData2.value.substring(1,2) + '&sessionJNum=' + this.searchData3.value.substring(1,2));
      // 埋点
      try{
          //LogCollection.contents["key"]="value";
          //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
          //2：收藏
          //3：下载
          //4：分享
          //5：购买
          //6：登录
          //7：注册
          //9：搜索
          //10：复制
          //11：点赞
          //12：评论
          LogCollection.send(3);
      }catch(e){}
    },
    download(url) {
      let a = document.createElement('a');
      a.href = url;
      let _id = Math.random()+Math.random();
      a.id = _id;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    //第一个下拉框
    SelectTimeFn1(val){
      this.fetchTable1(this.paramsData.stockCode,this.paramsData.enterpriseCode,'1',val.substring(1).replace(/[^0-9]/ig,""));//按产品
    },
    SelectTimeFn2(val){
      this.fetchTable2(this.paramsData.stockCode,this.paramsData.enterpriseCode,'2',val.substring(1).replace(/[^0-9]/ig,""));//按行业
    },
    SelectTimeFn3(val){
      this.fetchTable3(this.paramsData.stockCode,this.paramsData.enterpriseCode,'3',val.substring(1).replace(/[^0-9]/ig,""));//按地域
    },
    action(){
      // incomeType=收入类型分类 0:按产品 1:按行业 2:按地域
      this.fetchTimes();//获取所有时间的选项
      setTimeout(()=>{
        this.fetchTable1(this.paramsData.stockCode,this.paramsData.enterpriseCode,'1','-1');//按产品
        this.fetchTable2(this.paramsData.stockCode,this.paramsData.enterpriseCode,'2',this.searchData2.value.substring(1).replace(/[^0-9]/ig,""));//按行业
        this.fetchTable3(this.paramsData.stockCode,this.paramsData.enterpriseCode,'3',this.searchData3.value.substring(1).replace(/[^0-9]/ig,""));//按地域
        // $('.el-table thead tr th').css({'background':'#F7F7F7','color':'#333','font-size':'14px','font-weight':'400'});
      },900)
    },
    //获取所有时间的选项
    fetchTimes(){
      let _this = this;
      // api.baseInfoTableTwoTime(this.stockCode,this.enterpriseCode,'0').then(res=>{
      //   let data = res.data;
      //   _this.searchData1.select = data;
      //   _this.searchData1.value = data[0];
      // })   
      api.baseInfoTableTwoTime(this.paramsData.stockCode,this.paramsData.enterpriseCode,'2').then(res=>{
        let data = res.data;
        let tmpArr = [];
        if(data.length == 0){
          return;
        }
        for(let i=0;i<data.length;i++){
          tmpArr.push('第'+data[i]+'届');
        }
        _this.searchData2.select = tmpArr;
        _this.searchData2.value = tmpArr[0];
      })  
      api.baseInfoTableTwoTime(this.paramsData.stockCode,this.paramsData.enterpriseCode,'3').then(res=>{
        let data = res.data;
        let tmpArr = [];
        if(data.length == 0){
          return;
        }
        for(let i=0;i<data.length;i++){
          tmpArr.push('第'+data[i]+'届');
        }
        _this.searchData3.select = tmpArr;
        _this.searchData3.value = tmpArr[0];
      })  
    },
    fetchTable1(stockCode,enterpriseCode,executivesType,sessionNum){
      let _this = this;
      api.baseInfoTableTwo(stockCode,enterpriseCode,executivesType,sessionNum).then(res=>{
          let data = res.data;
          _this.tableData1 = data;
      })   
    },
    fetchTable2(stockCode,enterpriseCode,executivesType,sessionNum){
      let _this = this;
      api.baseInfoTableTwo(stockCode,enterpriseCode,executivesType,sessionNum).then(res=>{
          let data = res.data;
          _this.tableData2 = data;
      })   
    },
    fetchTable3(stockCode,enterpriseCode,executivesType,sessionNum){
      let _this = this;
      api.baseInfoTableTwo(stockCode,enterpriseCode,executivesType,sessionNum).then(res=>{
          let data = res.data;
          _this.tableData3 = data;
      })   
    }
  },
  mounted() {
  }
};
</script>
<style scoped lang="less">
@import '../../assets/less/style.less';
.right {
  flex: 1;
  height: auto;
  margin-right: 23px;
  display: flex;
  flex-direction: column;
  .rightTop {
    width: auto;
    height: auto;
    margin-right: 20px;
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    padding: 0 20px 10px;
    .title {
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #dfdfdf;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333;
      }
      .button {
        width: 88px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #3583ed;
        border-radius: 2px;
        color: #fefefe;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
      }
    }
    .con {
      width: auto;
      flex: 1;
      font-size: 14px;
      font-family: Microsoft YaHei;
      color: #404040;
      display: flex;
      flex-direction: column;
      p {
        padding-top: 10px;
      }
    }
  }
  .rightCenter {
    width: auto;
    height: 61px;
    line-height: 61px;
    margin-right: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .centerTit {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color:#fff;
    }
    .centerCon {
      width: auto;
      height: 61px;
      line-height: 61px;
      display: flex;
      .no {
        span {
          display: inline-block;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333;
        }
      }
      .excel {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3583ed;
        img {
          display: inline-block;
          width: 18px;
          height: 18px;
          transform: translate(0, 20%);
        }
      }
    }
  }
  .rightBottom {
    width: auto;
    height: auto;
    margin-right: 20px;
    margin-bottom: 40px;
    padding: 20px 20px 50px 20px;
    .tabulation {
      width: 100%;
      height: auto;
      // background: lightblue;
    }
  }
}
.mailTable, .mailTable tr, .mailTable tr td{ border:1px solid #08396A; }
.mailTable{ font-size: 14px; color: #4B4B4B; width:100%;font-family:Microsoft YaHei;}
.mailTable tr td{ border:1px solid #08396A; width: 80%; height: 35px; line-height: 35px; box-sizing: border-box; padding: 0 10px; }
.mailTable .column { background-color: #F7F7F7; color: #333333; font-size:14px;font-weight:bold;width:20%;}
.el-table thead{
  background-color: #F7F7F7!important; 
  color: #333333!important;
  font-size:14px!important;
  font-weight:bold!important;
}


</style>


// WEBPACK FOOTER //
// src/view/companyBaseInfo/management.vue